import { Navigate, useNavigate } from "react-router"
import { fileSchema, useProductParam } from "../utils"
import { ACQUISITION_FORM_LINKS } from "../links"
import { theme } from "../../../../../styles/stitches.config"
import { CenterWrapper } from "../components/CenterWrapper"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { ConsumptionPointForm } from "./ConsumptionPointForm"
import { ConsumptionPointFormValues, useStoredConsumptionPointFormValues } from "./consumptionPointForm.utils"
import { useFileUpload } from "../../acquisitionForm/useFileUpload"
import { toasts } from "../../../../../utils/toasts"
import { FormHeader } from "../components/FormHeader"
import { useAcquisitionProgress } from "../AcquisitionProgressContext"

export function ConsumptionPointPage() {
  const { customerType, contractInfo } = useAcquisitionProgress()
  const product = useProductParam()

  const [consumptionPointInfo, storeConsumptionPointInfo] = useStoredConsumptionPointFormValues()
  const navigate = useNavigate()
  const uploadFile = useFileUpload()
  const progress = useAcquisitionProgress()

  if (!customerType) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CUSTOMER_TYPE}`} />
  }

  if (!contractInfo || (customerType === "household" && !contractInfo.measurementTypeConsent)) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CONTRACT_TYPE(customerType)}`} />
  }

  if (product !== contractInfo.product) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CONSUMPTION_POINT(customerType, contractInfo.product)}`} />
  }

  if (contractInfo.product === "production") {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.PRODUCTION_POINT(customerType, contractInfo.product)}`} />
  }

  const handleReturn = () => {
    navigate(`..${progress.previousStepUrl}`)
  }

  const handleSubmit = async (values: ConsumptionPointFormValues) => {
    try {
      if (!values.lastBilling.bucketPath) {
        const lastBillingPath = await uploadFile(values.lastBilling as File)
        // flatten the file object before storing it, since File object serialization results in an empty object
        values.lastBilling = await fileSchema.parseAsync(values.lastBilling)
        values.lastBilling.bucketPath = lastBillingPath
      }

      if (
        values.contractInfo.terminationOption === "DO_NOT_TERMINATE" &&
        values.contractInfo.contractTermination &&
        !values.contractInfo.contractTermination.bucketPath
      ) {
        const contractTerminationPath = await uploadFile(values.contractInfo.contractTermination as File)
        // flatten the file object before storing it, since File object serialization results in an empty object
        values.contractInfo.contractTermination = await fileSchema.parseAsync(values.contractInfo.contractTermination)
        values.contractInfo.contractTermination.bucketPath = contractTerminationPath
      }

      storeConsumptionPointInfo(values)

      navigate(`..${progress.nextStepUrl}`)
    } catch {
      toasts.error("Nepodařilo se nahrát soubor vyúčtování. Zkuste to později.")
    }
  }

  return (
    <CenterWrapper>
      <FormHeader>Odběrné místo</FormHeader>

      <Spacer size={theme.space.s6} />

      <ConsumptionPointForm
        defaultValues={consumptionPointInfo}
        customerType={customerType}
        selectedProduct={contractInfo.product}
        onReturn={handleReturn}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={handleSubmit}
      />
      <Spacer size={theme.space.s12} />
    </CenterWrapper>
  )
}
